const OWA_ITEM_CLIPBAORD_MIME = "web application/owa-item-drag-data";

export { OWA_ITEM_CLIPBAORD_MIME };
